<app-header></app-header>
<div class="hero__upload">
    <div class="container">
        <div class="space-y-20">
            
            <h2 class="title">Dashboard</h2>

        </div>
    </div>
</div>
 
<div class="container">
    <div class="box in__upload mb-120">

        <div class="row">
            


            <div class="col-lg-6">
                 Bienvenue sur votre dashboard
            </div>
           
        </div>
    </div>
</div>
 
<app-footer></app-footer>

